export default __webpack_public_path__ + "static/media/undraw_page_not_found.d5e1bb57.svg";